import type { MethodArticle } from "./types";
import { getPaymentAdditions } from "./payment-additions";

const modules = import.meta.glob<{ article: MethodArticle }>("./methods/*.ts", { eager: true });

export const METHOD_ARTICLES: Record<string, MethodArticle> = Object.fromEntries(
  Object.values(modules)
    .filter((m) => Boolean(m?.article))
    .map((m) => [m.article.slug, { ...m.article, blocks: [...m.article.blocks, ...getPaymentAdditions(m.article.slug)] }]),
);

export function getMethodArticle(slug: string): MethodArticle | null {
  return METHOD_ARTICLES[slug] ?? null;
}

/** Ruwe woordentelling van een artikel, voor redactionele controle. */
export function articleWordCount(article: MethodArticle): number {
  let words = 0;
  for (const block of article.blocks) {
    if ("text" in block && block.text) words += block.text.split(/\s+/).length;
    if ("items" in block) words += block.items.join(" ").split(/\s+/).length;
    if (block.type === "table") words += block.rows.flat().join(" ").split(/\s+/).length;
  }
  return words;
}
